import PropTypes from "prop-types";
import React from "react";
import LocationAutocomplete from "./LocationAutocomplete";

const LOCATION_KEYS = ["location_string", "location_latitude", "location_longitude", "location_country_code"];

// Registers the location bundle via setValue only on selection (like VisibilityControl), so an
// untouched location sends no keys; Remove clears the whole bundle to explicit nulls.
function LocationField({ defaultValue = "", setValue, error = undefined }) {
  return (
    <div className="col-12">
      <div className="row">
        <label htmlFor="location" className="col-12 col-form-label">
          Location
        </label>
        <div className="col-12">
          <LocationAutocomplete
            id="location"
            defaultValue={defaultValue || ""}
            onSelect={(bundle) => Object.entries(bundle).forEach(([key, value]) => setValue(key, value))}
            onClear={() => LOCATION_KEYS.forEach((key) => setValue(key, null))}
          />
          {error && <span className="small text-danger">{error.message}</span>}
        </div>
      </div>
    </div>
  );
}

LocationField.propTypes = {
  defaultValue: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  error: PropTypes.shape({ message: PropTypes.string }),
};

export default LocationField;
